import {FC, useEffect, useRef} from 'react';
import {BasPromotionMonitoring, usePromotionTracking} from './TrackPromotions';

/**
 * ASFE-3146 - triggers the promotion impression event for BAS placement reserved spaces
 *
 * @returns null
 */
export const TrackBASMonitoring: FC<{
  basPromotionSource: BasPromotionMonitoring['originalSource'];
  monitoringId?: string;
}> = ({basPromotionSource, monitoringId = 'monitoring'}) => {
  const wasTracked = useRef(false);
  const track = useTrackBASMonitoring(basPromotionSource, monitoringId);

  useEffect(() => {
    if (!wasTracked.current) {
      track('impression');
      wasTracked.current = true;
    }
  }, []);

  return null;
};

export const useTrackBASMonitoring = (
  originalSource: BasPromotionMonitoring['originalSource'],
  monitoringId = 'monitoring',
) =>
  usePromotionTracking({
    promotion: {
      source: 'monitoring',
      originalSource,
      advertisement: {
        id: monitoringId,
        name: monitoringId,
      },
    },
    streamPosition: 0,
  });
